// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Layout/Layout.css */
.layout-container {
  display: flex;
  min-height: 100vh;
  background-color: var(--color-bg);
  overflow-x: hidden;
}

.main-content {
  flex: 1 1 auto;
  min-width: 0;
  width: calc(100% - var(--sidebar-width));
  margin-left: var(--sidebar-width);
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.page-content {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  padding: var(--page-padding-y) var(--page-padding-x);
  overflow-y: auto;
  overflow-x: hidden;
}

@media (max-width: 1024px) {
  :root {
    --sidebar-width: var(--sidebar-width-tablet);
  }
}

@media (max-width: 768px) {
  .main-content {
    width: 100%;
    margin-left: 0;
  }

  .header-controls .search-bar {
    display: none;
  }
}

@media (max-width: 600px) {
  .page-content {
    padding: 16px 12px;
  }
}

.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;
}

@media (max-width: 768px) {
  .sidebar.open ~ .mobile-overlay {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/Layout/Layout.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wCAAwC;EACxC,iCAAiC;EACjC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* src/components/Layout/Layout.css */\n.layout-container {\n  display: flex;\n  min-height: 100vh;\n  background-color: var(--color-bg);\n  overflow-x: hidden;\n}\n\n.main-content {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: calc(100% - var(--sidebar-width));\n  margin-left: var(--sidebar-width);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.page-content {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  padding: var(--page-padding-y) var(--page-padding-x);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n@media (max-width: 1024px) {\n  :root {\n    --sidebar-width: var(--sidebar-width-tablet);\n  }\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .header-controls .search-bar {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .page-content {\n    padding: 16px 12px;\n  }\n}\n\n.mobile-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 998;\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .sidebar.open ~ .mobile-overlay {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
